import { THEME_CONFIG } from "../../configs/AppConfig";
import {
  CHANGE_LOCALE,
  SWITCH_THEME,
  TOGGLE_COLLAPSED_NAV
} from "../constants/Theme";

const initTheme = {
  ...THEME_CONFIG,
};

const theme = (state = initTheme, action) => {
  switch (action.type) {
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.navCollapsed,
      };
    case CHANGE_LOCALE: {
      return {
        ...state,
        locale: action.locale.locale,
        direction: action.locale.direction,
      };
    }
    case SWITCH_THEME: {
      return {
        ...state,
        currentTheme: action.currentTheme,
      };
    }
   
    default:
      return state;
  }
};

export default theme;
